<template>

	<div class="row">

		<div class="col-md-6">
			<h4 style="text-decoration: none;font-weight: 600;text-align: right;">{{moduleNameLocal}}</h4>
		</div>
		<div class="col-md-6" v-if="localModulePermissions[moduleName]">

			<field label="Read" col-class="col-md-2"
				:params="{
					type: 'btn-group',
					buttons: [
						{text: 'Read',value:true},
						{icon: 'fa-times',value:false}
					]
				}"
				v-model="localModulePermissions[moduleName].read"
				v-on:change="permsChanged">
			</field>

			<field label="Write" col-class="col-md-2" 
				:params="{
					type: 'btn-group',
					buttons: [
						{text: 'Write',value:true},
						{icon: 'fa-times',value:false}
					]
				}"
				v-model="localModulePermissions[moduleName].write"
				v-on:change="permsChanged">
			</field>

			<hr>

		</div>

	</div>

</template>

<script type="text/javascript">
import Field from "./Field"

export default {
	name: "ModulePermssionControl",
	props: ["moduleName","modulePermissions"],
	components: {
		Field
	},
	data() {
		return {
			localModulePermissions: this.modulePermissions
		}
	},
	watch: {
		module() {
			this.localModulePermissions = this.modulePermissions
		},
		modulePermissions() {
			this.localModulePermissions = this.modulePermissions
		}
	},
	computed: {
		moduleNameLocal() {
			//just rename Jobs module label to Projects
			if (this.moduleName == 'Jobs')
				return "Projects"
			else if (this.moduleName == 'Users')
				return "Employees/Users"
			else
				return this.moduleName
		}
	},
	methods: {
		permsChanged() {
			this.$emit("permsChanged",this.localModulePermissions)
		}
	}
}

</script>

<style type="text/css" scoped>
	h4 {
		word-wrap: break-word;
	}
</style>